module.exports = __webpack_public_path__ + "static/lambsuitcase-8e851faeab3c41f2d1602d2b6280d9f7.jpeg";